/* THIS PAGE CONTAINS MOST OF THE FUNCTIONS USED BY COMPONENTS.
    EACH COMMENT TITLE IS BASED ON THE JS PAGE THAT USES THE FUNCTION */


// HEADER

const toggleSearchBar = (bar, setBar) => {
    setBar(!bar);
}

const toggleDropDown = (dropDown, setDropDown) => {
    setDropDown(!dropDown);
}

const toggleActiveLi = (id, lis, setLis) => {
    let arr = [...lis];
    arr = arr.map(arr => {
        arr.active = false;
        return arr;
    })
    arr = arr.map(arr => {
        if(arr.id === id) {
            arr.active = !arr.active;
        }
        return arr;
    })

    setLis(arr);
}

const searcher = (e, setSearch, search) => {
    const rez = e.target.value.replace(/ /g, "-").toLowerCase();
    setSearch(rez);
}

const searchData = (e, history, search, setSearch) => {
    e.preventDefault();   
    history.replace("/search/"+search);
    setSearch('');        
}


// ------HEADER END


// SEARCH 

const searchFor = (param, arr) => {
    const cleanParam = param.replace(/-/g, " ");
    const newArr = arr.filter(song => song.artist.replace(/-/g," ").toLowerCase().match(cleanParam) || song.title.replace(/-/g," ").toLowerCase().match(cleanParam) );
    return newArr;
}

// ------SEARCH END


// DOWNLOAD

const processDownload = (track, als, sings) => {
    const cleanParam = track.replace(/-/g, " ").toLowerCase();
    const id = cleanParam.substring(0, 1);
    const title = cleanParam.substring(2, cleanParam.length);
    const album = als.filter(album => album.id === Number(id) && album.title.replace(/-/g," ").toLowerCase().match(title) )[0];
    const single = sings.filter(single => single.id === Number(id) && single.title.replace(/-/g," ").toLowerCase().match(title) )[0];
    return album ? album : single;
}


// ------DOWNLOAD END







export { toggleSearchBar, toggleDropDown, toggleActiveLi, searcher, searchData, 
    searchFor,        
    processDownload }